import React, { FC } from "react";
import { faImages } from "@fortawesome/pro-regular-svg-icons/faImages";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Images: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faImages} {...props} />
);
